import { BarChartBig, Calculator, Headset, Mail, MapPin, MessageCircle, Settings } from "lucide-react-native";
import { subNavigationCollectionType } from "types/navigation.types";

const navigationCollection = [
	{ title: "Home", href: "/" },
	{ title: "My Sites", href: "/sites" },
	{ title: "Orders", href: "/orders" },
	{ title: "Products", href: "/products" },
	{ title: "Equipment", href: "/equipment" },
];

const navigationCollectionPublic = [
	{ title: "About Us", href: "/about-us" },
	{ title: "Products", href: "/products" },
	{ title: "Equipment", href: "/equipment" },
	{ title: "Services", href: "/services" },
	{ title: "Sustainability", href: "/sustainability" },
	{ title: "Articles", href: "/articles" },
];

const subNavigationCollection = [
	// { title: "Support", href: "/support", icon: MessageCircle },
	{ title: "Finance & Accounts", href: "/finance", icon: Calculator },
	{ title: "Reports", href: "/reports", icon: BarChartBig },
	{ title: "Admin", href: "/admin", icon: Settings },
];

const subNavigationCollectionPublic: subNavigationCollectionType = [
	{
		title: "Locations",
		href: "/locations",
		icon: MapPin,
	},
	{
		title: "Contact",
		href: "/contact",
		icon: Mail,
	},
];

const servicesNavigationItems = [
	{
		name: "Mobilisations",
		href: "/services/mobilisations",
	},
	{
		name: "Service & Maintenance",
		href: "/services/servicing-and-maintenance",
	},
	{
		name: "Training & Technical Support",
		href: "/services/training-and-technical-support",
	},
	{
		name: "Delivery",
		href: "/services/delivery",
	},
];

const sustainabilityNavigationItems = [
	{
		name: "Environmental",
		href: "/sustainability/environmental",
	},
	{
		name: "Social Initiatives",
		href: "/sustainability/social-initiatives",
	},
	{
		name: "Governance",
		href: "/sustainability/governance",
	},
	{
		name: "Certifications and Ratings",
		href: "/sustainability/certifications-and-ratings",
	},
];

const aboutUsNavigationItems = [
	{
		name: "Path 2 Partnership Program",
		href: "/about-us/path-2-partnership",
	},
	{
		name: "Careers",
		href: "/about-us/careers",
	},
	{
		name: "Our Values",
		href: "/about-us/our-values",
	},

	{
		name: "Aged Care",
		href: "/about-us/aged-care",
	},
	{
		name: "Education",
		href: "/about-us/education",
	},
	{
		name: "Gyms",
		href: "/about-us/gyms",
	},
	{
		name: "Healthcare",
		href: "/about-us/healthcare",
	},
	{
		name: "Hospitality",
		href: "/about-us/hospitality",
	},
	{
		name: "Mining",
		href: "/about-us/mining",
	},
	{
		name: "Shopping Centres",
		href: "/about-us/shopping-centres",
	},
	{
		name: "Stadiums",
		href: "/about-us/sport-stadiums",
	},
	{
		name: "Transport",
		href: "/about-us/transport",
	},
];

export { navigationCollection, navigationCollectionPublic, subNavigationCollection, subNavigationCollectionPublic, servicesNavigationItems, sustainabilityNavigationItems, aboutUsNavigationItems };
